import axios from 'axios';

export const getAllConfigurationItems = () =>
  axios.get('/common/common_category/list/').then(response => response.data);

export const toggleConfigurationItemState = id =>
  axios.put(`/common/common_category/${id}/toggle/`).then(response => response.data);
